import { getRetailerOrBrandToken } from "@faire/help-center-utils/serialized-data/getRetailerOrBrandToken";
import { logWarning } from "@faire/web/common/logging";
import { useEffect } from "react";
/**
 * Receives a function that tracks a page view and calls it with the user token
 * found in the page serialized data. If no user token is found, it calls the
 * tracker with an empty string and logs a warning.
 */
export var useTrackPageViewEffect = function useTrackPageViewEffect(trackPageView) {
  var retailerOrBrandToken = getRetailerOrBrandToken();
  useEffect(function () {
    if (retailerOrBrandToken) {
      trackPageView(retailerOrBrandToken);
    } else {
      logWarning("No retailer or brand token found, tracking page view empty token");
      trackPageView("");
    }
  }, [retailerOrBrandToken, trackPageView]);
};